import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash-es';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { getNatMutGroup, getSchedaPrevalenzaControl } from '../validators/helpers/natura-mutualistica-form-validators.helper';
import { getControl } from '@shared/helpers/form.helper';

export const setNatMutCkValoreQuantitaListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_CkValoreQuantita(form, store);
    my_CkValoreQuantitaPrimoAnno(form, store);
};

const my_CkValoreQuantita = (form: FormGroup, store: Store<Revisione53State>): void => {
    const naturaMutualisticaGroup = getNatMutGroup(form);
    const my_CkValoreQuantitaControl = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantita');

    my_CkValoreQuantitaControl.valueChanges.pipe(withChangeDebounced(my_CkValoreQuantitaControl)).subscribe((my_CkValoreQuantita) => {
        const my_QtaConfSoci = getControl(naturaMutualisticaGroup, 'my_SchedaPrevalenza.my_QtaConfSoci');
        const my_TotQtaConfSoci = getControl(naturaMutualisticaGroup, 'my_SchedaPrevalenza.my_TotQtaConfSoci');
        const my_B6confSoci = getControl(naturaMutualisticaGroup, 'my_SchedaPrevalenza.my_B6confSoci');
        const my_TotaleB6 = getControl(naturaMutualisticaGroup, 'my_SchedaPrevalenza.my_TotaleB6');

        if (my_CkValoreQuantita === 'V') {
            my_QtaConfSoci.patchValue(null, { emitEvent: false });
            my_TotQtaConfSoci.patchValue(null, { emitEvent: false });
        } else if (my_CkValoreQuantita === 'Q') {
            my_B6confSoci.patchValue(null, { emitEvent: false });
            my_TotaleB6.patchValue(null, { emitEvent: false });
        }

        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            const sez = myVerbaleClone.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza;
            sez.my_QtaConfSoci = my_QtaConfSoci.value;
            sez.my_TotQtaConfSoci = my_TotQtaConfSoci.value;
            sez.my_B6confSoci = my_B6confSoci.value;
            sez.my_TotaleB6 = my_TotaleB6.value;
            return myVerbaleClone;
        });
    });
};

const my_CkValoreQuantitaPrimoAnno = (form: FormGroup, store: Store<Revisione53State>): void => {
    const naturaMutualisticaGroup = getNatMutGroup(form);
    const my_CkValoreQuantitaPrimoAnnoControl = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantitaPrimoAnno');

    my_CkValoreQuantitaPrimoAnnoControl.valueChanges.pipe(withChangeDebounced(my_CkValoreQuantitaPrimoAnnoControl)).subscribe((my_CkValoreQuantitaPrimoAnno) => {
        const my_QtaConfSociPrimoAnno = getControl(naturaMutualisticaGroup, 'my_SchedaPrevalenza.my_QtaConfSociPrimoAnno');
        const my_TotQtaConfSociPrimoAnno = getControl(naturaMutualisticaGroup, 'my_SchedaPrevalenza.my_TotQtaConfSociPrimoAnno');
        const my_B6confSociPrimoAnno = getControl(naturaMutualisticaGroup, 'my_SchedaPrevalenza.my_B6confSociPrimoAnno');
        const my_TotaleB6PrimoAnno = getControl(naturaMutualisticaGroup, 'my_SchedaPrevalenza.my_TotaleB6PrimoAnno');

        if (my_CkValoreQuantitaPrimoAnno === 'V') {
            my_QtaConfSociPrimoAnno.patchValue(null, { emitEvent: false });
            my_TotQtaConfSociPrimoAnno.patchValue(null, { emitEvent: false });
        }
        if (my_CkValoreQuantitaPrimoAnno === 'Q') {
            my_B6confSociPrimoAnno.patchValue(null, { emitEvent: false });
            my_TotaleB6PrimoAnno.patchValue(null, { emitEvent: false });
        }

        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            const sez = myVerbaleClone.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza;
            sez.my_QtaConfSociPrimoAnno = my_QtaConfSociPrimoAnno.value;
            sez.my_TotQtaConfSociPrimoAnno = my_TotQtaConfSociPrimoAnno.value;
            sez.my_B6confSociPrimoAnno = my_B6confSociPrimoAnno.value;
            sez.my_TotaleB6PrimoAnno = my_TotaleB6PrimoAnno.value;
            return myVerbaleClone;
        });
    });
};
